<template>
  <div class="publicWelfare-container content-bg" :class="{
    isMobile: isMobile()
  }">
    <commonTop
      :moduleData="moduleData"
    />

    <div class="common-content-box sys-max-width">
      <div class="content grid lg-mx lg:grid-cols-3 md:grid-cols-3 grid-cols-1 gap-8">
        <div @click="goDetail(item)" class="item" v-for="(item, index) in contentList" :key="index">
          

          <div class="img">
            <img v-if="item.cover" class="img-common" :src="item.cover.url" alt="">
          </div>

          <div class="item-content">

            <div class="top-title line-clamp-1">{{ item.title }}</div>

            <div class="desc line-clamp-3">
              {{ item.summary }}
            </div>

            <div class="more primary-color flex items-center">
              <div style="margin-right: 7px;">查看更多</div>
              <div class="el-icon-arrow-right"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="page text-center">
        <el-pagination
          background
          @current-change="currentPageChange"
          :current-page.sync="page"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { MODULE_CONFIG } from '@/config/index'
import moduleMixins from '@/mixins/module'
import pageMixins from '@/mixins/page'
import { isMobile } from '@/utils/index'
import { fetchContentList } from '@/api/content'

export default {
  mixins: [moduleMixins, pageMixins],
  components: {

  },

  data() {
    return {
      moduleId: MODULE_CONFIG.WELFARE,

      pageSize: 9,

      contentList: []
    }
  },
  methods: {
    isMobile,
    goDetail(item) {
      this.$router.push({
        name: 'contentDetail',
        query: {
          moduleId: item.pid,
          moduleSecId: item.cate_id,
          contentId: item.object_code
        }
      })
    },
    async getContentList() {
      try {
        const { data, total } = await fetchContentList({
          page: this.page,
          // pageSize: this.pageSize,
          pageSize: 9,
          pid: this.moduleId
        })

        this.contentList = data
        this.total = total
      } catch (error) {

      }
    }
  },
  created() {
    this.getContentList()
  }
}
</script>

<style lang="scss">
.publicWelfare-container {
  .content {
    margin-bottom: 82px;

    .item {
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 0px rgba(26, 104, 202, 0.1);
      border-radius: 10px;
      cursor: pointer;
      transition: all .2s;
      
      &:hover {
        transform: translateY(-4px);
      }

      .img {
        height: 158px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        // margin-bottom: 10px;
        overflow: hidden;
      }


      .item-content {
        padding: 20px 20px;

        .top-title {
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          font-size: 18px;
          font-weight: normal;
          color: #0A1121;
          margin-bottom: 10px;
        }

        .desc {
          font-size: 14px;
          font-weight: normal;
          color: #9199A1;
          line-height: 20px;
          height: 60px;
          margin-bottom: 25px;
        }

        .more {

        }
      }
    }
  }

  // .page {
  //   margin-bottom: ;
  // }
}
</style>
